import React, { useEffect, useRef, useState } from "react";
import { Button, Grid } from "@mui/material";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import PopUp from "./Component/PopUp";
import { useAppServices } from "hook/services";
import img_empty from "assets/images/img.jpg";
import { useUploadImage } from "hook/services";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import { uploadImageToGhl } from "hook/services";
import { useAgencyInfo } from "context/agency";
import toast from "react-hot-toast";
import ReactCropModal from "layouts/super-admin/settings/Configurator/components/ReactCropModal/ReactCropModal";
import SoftTypography from "components/SoftTypography";

function Blogs({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);
  const uploadImage = useUploadImage();
  const [blogsData, setBlogsData] = useState([]);
  const [agency] = useAgencyInfo();
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [tempImageFile, setTempImageFile] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [UploadType, setUploadType] = useState("");
  const [MainImage, setMainImage] = useState("");
  const [CoverImage, setCoverImage] = useState("");

  const getBlogs = async () => {
    const { response } = await AppService.blogs.Get({
      query: `account_id=${formData._id}`,
    });
    if (response) {
      setBlogsData(response.data);
    }
  };

  useEffect(() => {
    if (popup) {
      setTimeout(() => {
        if (quillRef.current && !quillInstance.current) {
          quillInstance.current = new Quill(quillRef.current, {
            theme: "snow",
          });
        }
        if (selectedBlog && quillInstance.current) {
          quillInstance.current.root.innerHTML = selectedBlog.description || "";
        }
      }, 100);
    }
    return () => {
      if (!popup && quillInstance.current) {
        quillInstance.current = null;
      }
    };
  }, [popup, selectedBlog]);

  const openPopup = () => setPopup(true);

  const closePopup = () => {
    setPopup(false);
    setSelectedBlog(null);
    quillInstance.current = null;
  };

  const openCropModal = (file) => {
    setTempImageFile(file);
    setCurrentImage(URL.createObjectURL(file));
    setCropModalOpen(true);
  };

  const handleCroppedImage = async (blob) => {
    if (!blob) return;

    setImageUploading(true);
    try {
      const file = new File([blob], "cropped-blog-image.jpg", { type: "image/jpeg" });
      const image_response = await uploadImageToGhl(file, agency);

      if (image_response?.data) {
        if(UploadType === "image"){
           if (selectedBlog) {
          setSelectedBlog(prev => ({
            ...prev,
            image: image_response?.data
          }));
        }else{
            setMainImage(image_response?.data);
        }
        }
        if(UploadType === "cover_image"){
           if (selectedBlog) {
          setSelectedBlog(prev => ({
            ...prev,
            cover_image: image_response?.data
          }));
        }else{
          setCoverImage(image_response?.data);
        }
      }
        setTempImageFile(null);
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
      setCropModalOpen(false);
    }
  };

  const handleImageUpload = async (e,type) => {
    const file = e.target.files[0];
    if (file) {
      openCropModal(file);
      setUploadType(type);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const description = quillInstance.current ? quillInstance.current.root.innerHTML.trim() : "";

    const payload = {
      title: e.target?.title?.value,
      image: MainImage || selectedBlog?.image || "",
      cover_image: CoverImage || selectedBlog?.cover_image || "",
      description,
      date: new Date().toISOString(),
      account_id: formData?._id,
      agency_id: formData?.agency_id,
    };

    let response;

    if (selectedBlog) {
      response = await AppService.blogs.Update({
        payload: { ...payload, _id: selectedBlog._id },
      });
    } else {
      response = await AppService.blogs.Create({ payload });
    }

    if (response) {
      handleRefresh();
      setPopup(false);
      setSelectedBlog(null);
      getBlogs();
      toast.success(selectedBlog ? "Blog updated successfully!" : "New blog created successfully!");
    } else {
      toast.error("Error updating Data");
    }

    setLoading(false);
  };

  const deleteBlog = async (blog) => {
    const { response } = await AppService.blogs.Delete({
      query: `_id=${blog._id}`,
    });

    if (response) {
      handleRefresh();
      getBlogs();
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting attachment");
    }
  };

  const editBlog = (blog) => {
    setSelectedBlog(blog);
    if (quillInstance.current) {
      quillInstance.current.root.innerHTML = blog.description || "";
    }
    openPopup();
  };

  useEffect(() => {
    getBlogs();
  }, [formData]);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "end", margin: "0 10px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={openPopup}
          style={{ color: "white", background: "black" }}
        >
          New Blog
        </Button>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {blogsData?.map((blog, index) => (
          <SoftBox
            key={index}
            style={{
              margin: "10px",
              width: "30%",
              borderRadius: "10px",
              border: "1px solid #f5f5f5",
              padding: "10px",
            }}
          >
            <img
              src={blog.image || img_empty}
              alt={blog.title}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "8px"
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
              <h4 style={{ margin: 0 }}>{blog.title}</h4>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  color="white"
                  onClick={() => editBlog(blog)}
                  style={{ minWidth: "auto", padding: "8px" }}
                >
                  <img src={editIcon} width={20} style={{ cursor: "pointer" }} alt="Edit" />
                </Button>
                <Button
                  variant="contained"
                  color="white"
                  style={{
                    background: "#e44d36",
                    color: "#fff",
                    minWidth: "auto",
                    padding: "8px"
                  }}
                  onClick={() => deleteBlog(blog)}
                >
                  <img src={deleteIcon} width={20} style={{ cursor: "pointer" }} alt="Delete" />
                </Button>
              </div>
            </div>
          </SoftBox>
        ))}
      </div>

      <PopUp open={popup} handleClose={closePopup} title={selectedBlog ? "Edit Blog" : "New Blog"}>
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Title</label>
                  <input
                    className="form-control-agust"
                    name="title"
                    type="text"
                    placeholder="Title"
                    defaultValue={selectedBlog?.title || ""}
                    required
                  />
                </SoftBox>
              </div>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Image</label>
                  <input
                    className="form-control-agust"
                    name="image"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, "image")}
                  />
                  {selectedBlog?.image && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={selectedBlog.image}
                        alt="Current blog"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "8px"
                        }}
                      />
                    </div>
                  )}
                </SoftBox>
              </div>
            </div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Cover Image</label>
                  <input
                    className="form-control-agust"
                    name="cover_image"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageUpload(e, "cover_image")}
                  />
                  <Grid item xs={12} display={"flex"} alignItems="center" style={{ padding: 0 }}>
                    <SoftTypography
                      variant="p"
                      className="roboto-family"
                      style={{ fontSize: "14px", marginTop: "4px" }}
                    >
                      1MB maximum size. 5:2 ratio. Recommended dimensions: 1752 x 716 pixels.
                    </SoftTypography>
                  </Grid>
                  {selectedBlog?.cover_image && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={selectedBlog.cover_image}
                        alt="Current blog"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          borderRadius: "8px"
                        }}
                      />
                    </div>
                  )}
                </SoftBox>
              </div>
            </div>
            <div style={{ padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Description</label>
                <div ref={quillRef} style={{ height: "250px", marginBottom: "20px" }} />
              </SoftBox>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              margin: "0 10px",
            }}
          >
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={loading}
              style={{ color: "white", background: "black" }}
            >
              {
                loading ? "Processing..." :
                  selectedBlog ? "Update Blog" : "Save Blog"}
            </Button>
          </div>
        </form>
      </PopUp>

      <ReactCropModal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        currentImage={currentImage}
        onCropComplete={handleCroppedImage}
        aspectRatio={UploadType === "image" ? 1 / 1 : 7 / 2}
      />
    </div>
  );
}

export default Blogs;